import { render, staticRenderFns } from "./StudyResultsContent.vue?vue&type=template&id=4ba810b6&"
import script from "./StudyResultsContent.vue?vue&type=script&lang=js&"
export * from "./StudyResultsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports